<template>
  <div class="condition_query">
    <h1>{{ $t("tool.querytitle") }}</h1>
    <div class="form_com">
      <el-row class="search_com">
        <el-col :span="11">
          <el-input
            placeholder="Please Enter Code or Name"
            v-model="hsCode"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" class="query" @click="queryCode">{{ $t("home.book") }}</el-button>
        </el-col>
        <el-col :span="3">
          <p @click="demoCode">{{ $t("tool.exp") }}:Jewelry</p>
        </el-col>
      </el-row>
      <el-table
        class="table_com"
        :data="hsData"
        stripe
        style="width: 100%"
        v-if="flag == 'on'"
      >
        <el-table-column prop type label="Serial Number" width="166">
          <div slot-scope="scope">
            {{ isData == "Y" ? scope.$index + 1 : "—" }}
          </div>
        </el-table-column>
        <el-table-column
          prop="HsCode"
          label="Code"
          width="222"
        ></el-table-column>
        <el-table-column
          prop="HsName"
          label="Name"
          width="302"
        ></el-table-column>
        <el-table-column prop label="Operating" width="150">
          <div slot-scope="scope">
            <p v-if="isData == 'Y'" @click="hsDetail(scope.row.Entity_syscode)">
              {{ $t("query.details") }}
            </p>
            <span v-else>—</span>
          </div>
        </el-table-column>
      </el-table>
      <el-row
        class="hsdetail_cont"
        v-for="item in hsdetailData"
        :key="item.HsCode"
        v-else
      >
        <el-row>Details of {{ item.HsCode }}</el-row>
        <el-row class="title_com"> {{ $t("tool.tariffInfo") }}</el-row>
        <el-table :data="hsdetailData" border style="width: 100%">
          <el-table-column
            prop="Rate_most_favoured"
            label="Best Prices(%)MFN"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="Rate_common"
            label="GEN(%)"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="Rate_added"
            label="VAT(%)"
          ></el-table-column>
          <el-table-column
            prop="Rate_refund"
            label="ED(%)"
            width="180"
          ></el-table-column>
          <el-table-column prop="Measure_unit" label="Unit"></el-table-column>
          <el-table-column
            prop
            label="Tariffs on the United States and Canada(%)"
            width="170"
          >
            <div slot-scope="scope">No data</div>
          </el-table-column>
        </el-table>
        <el-row class="title_com">{{ $t("tool.condition") }}</el-row>
        <el-row class>{{ item.Regulate_condition }}</el-row>
        <el-row class="title_com">{{ $t("tool.elements") }}</el-row>
        <el-row>{{ item.Declare_element }}</el-row>
      </el-row>
    </div>
  </div>
</template>
<style type="text/css" scoped="true">
@import "~@/assets/css/view/tool/tool.css";
</style>
<script type="babel">
export default {
    data: function() {
        return {
        hsCode: "",
        NationCode: "",
        NationName: "",
        flag: "on",
        isData: "",
        hsData: [
            {
                HsCode: "—",
                HsName: "—"
            }
        ],
        hsdetailData: {},
        demoData: [
            {
                HsCode: "7117190000",
                HsName: "Other platinum jewelry machine parts (whether packaged or not)",
                Entity_syscode: "118425059"
            },
            {
                HsCode: "7117190000",
                HsName: "Other platinum jewelry machine parts (whether packaged or not)",
                Entity_syscode: "118425059"
            },
            {
                HsCode: "7117190000",
                HsName: "Other platinum jewelry machine parts (whether packaged or not)",
                Entity_syscode: "118425059"
            }
        ]
        };
    },
    methods: {
        queryCode: function() {
            var vm = this;
            var reg = /^[0-9\u4e00-\u9fa5]+$/;
            var nums = /^[0-9]+$/;
            vm.flag = "on";
            if (!vm.hsCode) {
                vm.$bus.emit("commmon-notification", null, "The query condition cannot be empty");
            } else if (
                (nums.test(vm.hsCode) == true && vm.hsCode.length < 3) ||
                reg.test(vm.hsCode) == false
            ) {
                vm.$bus.emit("commmon-notification", null, "Please enter the correct code");
            } else {
                var data = {
                    x: "queryByHscodeOrHsname",
                    y: vm.hsCode,
                    token: ""
                };
                axios
                .post("/WeChatQueryReceiptServletEngineV2", data)
                .then(function(res) {
                    var isDatas = (vm.isData = res.data.ResultData.isData);
                    if (isDatas == "Y") {
                        var hsDatas = res.data.ResultData.Infos;
                        if (hsDatas.length) {
                            vm.hsData = hsDatas;
                        } else {
                            var arr = [];
                            arr.push(hsDatas.Info);
                            vm.hsData = arr;
                        }
                    } else {
                        vm.hsData = undefined;
                    }
                });
            }
        },
        demoCode: function() {
            var vm = this;
            vm.hsData = vm.demoData;
            vm.isData = "Y";
            vm.flag = "on";
        },
        hsDetail: function(Entity_syscode) {
            var vm = this;
            vm.flag = "off";
            var data = {
                x: "queryByEntitySyscode",
                y: Entity_syscode,
                token: ""
            };
            axios
                .post("/WeChatQueryReceiptServletEngineV2", data)
                .then(function(res) {
                var hsdetailDatas = res.data.ResultData;
                if (hsdetailDatas) {
                    vm.hsdetailData = hsdetailDatas;
                }
            });
        }
    }
};
</script>
